module.exports = __webpack_public_path__ + "img/bg2.37c45d28.png";